// Texty pásu dopravy zdarma (benefitBand.js) — modal na detailu i pokladna.
export default {
  leftA: 'Objednejte ještě za ',
  leftB: (scope) => ' a dopravu ' + scope + ' máte zdarma.',
  reached: (scope) => 'Dopravu ' + scope + ' máte zdarma.',
  barLabel: 'Postup k dopravě zdarma',
};
